<template>
	<div>
		<div id="auditTop" class="main-page-content">
			<PageHeaderLayout :isBack="true">
				<div style="background: #fff; padding: 20px 20px">
					<el-form
						:inline="true"
						:model="searchCondition"
						class="demo-form-inline"
					>
						<el-form-item label="姓名">
							<el-input
								clearable
								v-model="searchCondition.realname"
								placeholder="请输入姓名"
							></el-input>
						</el-form-item>
						<el-form-item label="证件号码">
							<el-input
								clearable
								v-model="searchCondition.id_number"
								placeholder="请输入证件号码"
							></el-input>
						</el-form-item>
						<el-form-item label="任务服务类型">
							<el-input
								clearable
								v-model="searchCondition.category_title"
								placeholder="请输入服务类型"
							></el-input>
						</el-form-item>
						<el-form-item label="交付状态">
							<el-select
								clearable
								v-model="searchCondition.deliver_status"
								placeholder="交付状态"
							>
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="时间">
							<DatePicker @dataSearch="dataSearch" />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
							<el-button
								style="margin-left: 24px"
								:loading="downloadLoading"
								type="primary"
								icon="el-icon-document"
								@click="handleDownload"
								>导出</el-button
							>
						</el-form-item>
					</el-form>
					<div style="marrgin: 0 20px">
						<div class="table-sys-box">
							<el-button type="primary" @click="examineAll">一键审核</el-button>
						</div>
						<el-table
							:data="tableData"
							style="width: 100%"
							:header-cell-style="{ background: '#fbfbfb' }"
							@selection-change="handleSelectionChange"
						>
							<el-table-column
								type="selection"
								width="55"
								:selectable="event_selectable"
							></el-table-column>
							<template v-if="activeName === '2'">
								<el-table-column
									prop="realname"
									label="姓名"
									align="center"
								></el-table-column>
								<el-table-column
									prop="id_number"
									label="证件号码"
									align="center"
								></el-table-column>
								<el-table-column
									prop="category_title"
									label="服务类型"
									align="center"
								></el-table-column>
							</template>

							<el-table-column
								prop="deliver_status"
								label="状态"
								align="center"
							>
								<template slot-scope="scope">
									{{ scope.row.q_deliver_status }}
								</template>
							</el-table-column>
							<el-table-column
								prop="deliver_status"
								label="审核信息"
								align="center"
							>
								<template slot-scope="scope">
									{{ scope.row.deliver_examine_at }}
									<div
										style="text-align: center; margin-top: 20px"
										v-if="scope.row.deliver_status === 3"
									>
										<span slot="footer" class="dialog-footer">
											<el-button
												@click="showBohui(scope.row)"
												size="mini"
												type="primary"
												>驳回意见</el-button
											>
										</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="操作" align="center">
								<template slot-scope="scope">
									<el-button
										v-if="scope.row.deliver_status == 1"
										size="mini"
										type="primary"
										@click="taskClick(scope.row, 'examine')"
										>审核</el-button
									>
									<el-button size="mini" @click="taskClick(scope.row, 'edit')"
										>编辑</el-button
									>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>

				<el-dialog
					title="驳回意见"
					:visible.sync="bohuiDialog.show"
					width="30%"
					@close="closeBohui"
				>
					<div>
						{{ bohuiDialog.data.deliver_message }}
					</div>
					<div style="text-align: center; margin-top: 20px">
						<span slot="footer" class="dialog-footer">
							<el-button @click="closeBohui" size="mini" type="primary"
								>确 认</el-button
							>
						</span>
					</div>
				</el-dialog>
				<el-dialog
					title="审核"
					:visible.sync="shenheDialog.show"
					width="50%"
					@close="userClose"
				>
					<div class="shenhe-content-tip">
						tip:请认真核对任务说明及上传的相关图片资料，全面核查业务相关信息；税务部门将对业务真实性开展不定期抽查，确保业务开展合规有序。
					</div>
					<el-radio-group v-model="shenheDialog.data.examine_status">
						<el-radio :label="1">审核通过</el-radio>
						<el-radio :label="2">审核拒绝</el-radio>
					</el-radio-group>
					<div
						v-if="shenheDialog.data.examine_status == 2"
						style="margin-top: 30px"
					>
						<el-form label-width="90px" ref="userRef">
							<el-form-item prop="textarea">
								<el-input
									type="textarea"
									placeholder="请输入原因"
									v-model="shenheDialog.data.examine_message"
									maxlength="100"
									show-word-limit
									:rows="5"
								></el-input>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="closeShenhe" style="margin-right: 24px;">取 消</el-button>
						<el-button type="primary" @click="confirmShenhe">确 定</el-button>
					</span>
				</el-dialog>
				<el-pagination
					style="float: right"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page.sync="pagege.current_page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pagege.page_size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagege.total"
				></el-pagination>
			</PageHeaderLayout>
		</div>
	</div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
export default {
	components: {
		DatePicker,
		PageHeaderLayout,
	},
	watch: {
		"$route.matched": function(n, o) {
			console.log(o);
			if (n.length === 2) {
				this.init();
			}
		},
	},
	data() {
		return {
			query: {},
			shenheData: [],
			activeName: "2",
			options_text: ["待交付", "待审核", "交付通过", "交付未通过"], //0待交付1待审核2交付通过3交付未通过
			options: [
				{
					value: "0",
					label: "待交付",
				},
				{
					value: "1",
					label: "待审核",
				},
				{
					value: "2",
					label: "交付通过",
				},
				{
					value: "3",
					label: "交付未通过",
				},
			],
			searchCondition: {},
			pagege: {},
			currentPage2: "",
			id: "",
			Status: "",
			mission_content: "",

			tableData: [],
			selecTabletData: [],
			ispage: 1,
			num: 10,

			downloadLoading: false,
			bohuiDialog: {
				show: false,
				data: {},
			},
			shenheDialog: {
				show: false,
				data: {
					ids: [],
					examine_status: 1, //1通过2拒绝
					examine_message: "", //审核拒绝原因
				},
			},
		};
	},
	created() {
		this.query = this.$route.query;
		this.init();
	},

	methods: {
		closeShenhe() {
			this.shenheDialog = {
				show: false,
				data: {},
			};
		},
		async confirmShenhe() {
			let params = {
				ids: this.shenheDialog.data.ids,
				examine_status: this.shenheDialog.data.examine_status,
				examine_message: this.shenheDialog.data.examine_message,
			};
			await this.$api.post_deliver_privatejoinAllExamine(params);
			this.$message.success("审核成功");
			this.closeShenhe();
			this.init();
		},
		examineAll() {
			if (this.selecTabletData.length === 0) {
				this.$message.warning("您当前未进行勾选，请勾选后再进行操作");
				return;
			}
			this.shenheDialog.data.ids = this.selecTabletData.map((item) => item.id);
			this.shenheDialog.show = true;
		},
		handleSelectionChange(data) {
			this.selecTabletData = data;
			console.log(this.selecTabletData);
		},
		// 是否禁用
		event_selectable(row) {
			if (row.deliver_status == "1") {
				return true;
			}
		},
		closeBohui() {
			this.bohuiDialog = {
				show: false,
				data: {},
			};
		},
		showBohui(row) {
			this.bohuiDialog = {
				show: true,
				data: row,
			};
			console.log(this.bohuiDialog, "bohuiDialog");
		},
		async handleDownload() {
			this.downloadLoading = true;
			let list = await this.init("export");
			console.log(list, "list");
			if (list.length === 0) {
				this.$message.warning("暂无数据");
				this.downloadLoading = false;
				return;
			}
			import("@/excel/Export2Excel").then((excel) => {
				let sHeader = [
					"姓名",
					"证件号码",
					"服务类型",
					"状态",
					"审核时间",
					"驳回意见",
					"交付内容",
					"交付图片",
				];
				const data = this.formatJson(list);
				console.log(data, "data");
				const time = new Date().getTime() + Math.random() * 1000;
				let filename = `${time}`;
				excel.export_json_to_excel({
					header: sHeader, //Header Required
					data, //Specific data Required
					filename: filename, //Optional
					autoWidth: true, //Optional
					bookType: this.exportType, //Optional
				});
				this.downloadLoading = false;
			});
		},
		formatJson(jsonData) {
			return jsonData.map((v) => {
				console.log(v, "v");
				let {
					realname,
					id_number,
					category_title,
					q_deliver_status,
					deliver_examine_at,
					deliver_message,
					deliver_content,
					deliver_images,
				} = v;
				let arr = [
					realname,
					id_number,
					category_title,
					q_deliver_status,
					deliver_examine_at,
					deliver_message,
					deliver_content,
					deliver_images,
				];

				return arr;
			});
		},
		// 搜索
		searchButton() {
			this.init();
		},
		//获取选中日期的值
		dataSearch(value) {
			console.log(value);
			this.searchCondition.time = {};
			this.searchCondition.time.start_time = value[0];
			this.searchCondition.time.end_time = value[1];
		},
		handleClick(tab) {
			this.activeName = tab.name;
			this.init();
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.num = val;
			this.ispage = 1;
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.ispage = val;
			this.init();
		},
		//详情
		taskClick(row, type) {
			this.$router.push({
				path: "/Taskaudit/deliveryPrivatePersonnelDetail",
				query: { id: row.id, type },
			});
		},
		async init(type) {
			let objects = {
				current_page: this.ispage,
				page_size: this.num,
				realname: this.searchCondition.realname,
				id_number: this.searchCondition.id_number,
				category_title: this.searchCondition.category_title,
				deliver_status: this.searchCondition.deliver_status,
				time: this.searchCondition.time,
				mission_id: this.query.id,
			};
			if (type === "export") {
				objects.page_size = 9999999;
			}
			let res = {};
			res = await this.$api.post_deliver_privatejoinList(objects);
			let { data, pages } = res;
			let tableData = data.map((item) => {
				console.log(item, "item", this.options_text, item.deliver_status);
				return {
					...item,
					q_deliver_status: this.options_text[item.deliver_status],
				};
			});
			if (type === "export") {
				return tableData;
			}
			console.log(pages, res);
			this.tableData = tableData;
			this.pagege = pages;
		},

		taskseeClick(row) {
			this.mission_content = row.mission_content || row.job_remark;
			console.log(row);
			this.taskseedialogVisible = true;
		},
		userClose() {},
		examineClick(row) {
			this.id = row.id;
			this.radio = 1;
			this.userList.textarea = "";
			this.examinedialogVisible = true;
		},
		async userInfo() {
			let obj = {
				examine_status: this.radio,
				examine_reason: this.userList.textarea,
			};
			console.log(obj, "obj");

			if (obj.examine_status == 2 && obj.examine_reason == "") {
				this.$message.error("请填写拒绝理由");
			} else {
				let Status = "";
				if (this.activeName === "1") {
					Status = await this.$api.postStatus(this.id, obj);
				} else {
					Status = await this.$api.postDaily_taskExamine(this.id, obj);
				}
				this.$nextTick(() => {
					if (Status) {
						this.$message.success("审核成功!");
						this.init();
						this.examinedialogVisible = false;
					}
				});
			}
		},
	},
};
</script>

<style scoped lang="scss">
.main-page-content {
	padding-bottom: 50px;
}
.table-sys-box {
	margin-bottom: 20px;
}
.shenhe-content-tip {
	margin-bottom: 20px;
	font-size: 12px;
	color: red;
}
::v-deep .el-table-column--selection .cell {
	padding-left: 15px;
}
</style>
